import { render, staticRenderFns } from "./ScientificPreparation.vue?vue&type=template&id=4a7a3380&"
import script from "./ScientificPreparation.vue?vue&type=script&lang=js&"
export * from "./ScientificPreparation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports